module.exports = __webpack_public_path__ + "static/media/kayden-kross-lose.423d9f4e.jpg";